import { getErrorFromAPI, handleToastMutation } from '@/helpers/toast';
import commonSlice from '@/redux/features/common.slice';
import { Dispatch } from '@reduxjs/toolkit';

// Dispatches a success or error toast from an RTK mutation result. Returns true on success.
export function handleMutationResult(dispatch: Dispatch, res: any): boolean {
  if ('data' in res && res.data && res.data?.state === 1) {
    dispatch(commonSlice.actions.handleToast(handleToastMutation(res)));
    return true;
  }
  dispatch(commonSlice.actions.handleToast({ isOpen: true, content: getErrorFromAPI(res), error: true }));
  return false;
}
